import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import {
  Autocomplete,
  Avatar, Box, Card,
  CardContent, Checkbox, Chip, FormControl, Grid, IconButton, InputAdornment, InputLabel, Link, List, ListItem, Menu, MenuItem, OutlinedInput, Paper, Select, Stack, Tab, Tabs, TextField, Typography
} from '@mui/material';
import { ArrowForward, CloseOutlined, DeleteOutline, Search, TrendingUp } from '@mui/icons-material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import LoopIcon from '@mui/icons-material/Loop';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LinearProgress from "@mui/material/LinearProgress";
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import statusIcon from "../../../assets/svg/pending.svg";
import "./AllIncentives.css";
import axios from "axios";
import { newHost } from './../../Categories/CategoryProfile';
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination, 
} from "@mui/material";
import { FaCircle } from "react-icons/fa";
import { MdContentCopy, MdDeleteOutline, MdOutlineModeEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { IoPlayOutline } from "react-icons/io5";
import { CiPause1 } from "react-icons/ci";


const stats = [
  {
    title: "Total Incentives",
    value: 128,
    subtitle: "All time",
  },
  {
    title: "Active",
    value: 74,
    subtitle: "+57.8% of total",
  },
  {
    title: "Scheduled",
    value: 12,
    subtitle: "Upcoming",
  },
  {
    title: "Draft",
    value: 16,
    subtitle: "In progress",
  },
  {
    title: "Expired",
    value: 26,
    subtitle: "No longer active",
  }
];

const recentUpdates = [
  {
    name: "Competition 100",
    initials: "C",
    bg: "#F6E9FC",
    color: "#7E1BAD"
  },
  {
    name: "Welcome 2026",
    initials: "P",
    bg: "#F0F8FF",
    color: "#3E9FF6"
  },
  {
    name: "Oil Change Voucher",
    initials: "V",
    bg: "#FFFAEA",
    color: "#FEB91E"
  },
  {
    name: "Invite & Earn",
    initials: "R",
    bg: "#F4F8F0",
    color: "#8CB369"
  },
  {
    name: "Gold Tire Reward",
    initials: "L",
    bg: "#FFF4F0",
    color: "#FC6C4F"
  }
];



 

// actions


const ACTION_CONFIG = {
  view: {
    label: "View",
    icon: <MdOutlineRemoveRedEye size={18} />,
    color: "#000",
    bulkEligible: false,
  },
  edit: {
    label: "Edit",
    icon: <MdOutlineModeEdit size={18} />,
    color: "#000",
    bulkEligible: false,
  },
  duplicate: {
    label: "Duplicate",
    icon: <MdContentCopy size={18} />,
    color: "#000",
    bulkEligible: false,
  },
  delete: {
    label: "Delete",
    icon: <MdDeleteOutline size={18} />,
    color: "#A80101",
    bulkEligible: true,
    bulkIcon: <DeleteOutline sx={{ color: "#A80101" }} />,
    bulkBorderColor: "#A8010133",
  },
  activate: {
    label: "Activate",
    icon: <IoPlayOutline size={18} />, 
    color: "#04B22E",
    bulkEligible: true,
    bulkIcon: <IoPlayOutline color= "#04B22E" />,
    bulkBorderColor: "#04B22E33",
  },
  pause: {
    label: "Pause",
    icon: <CiPause1 size={18} />, 
    color: "#FEB91E",
    bulkEligible: true,
    bulkIcon: <CiPause1  color= "#FEB91E"/>,
    bulkBorderColor: "#FEB91E4D",
  },
  // disable: {
  //   label: "Disable",
  //   icon: <MdDeleteOutline size={18} />,
  //   color: "#A80101",
  //   bulkEligible: true,
  //   bulkIcon: <DeleteOutline sx={{ color: "#A80101" }} />,
  //   bulkBorderColor: "#A8010133",
  // },
};
const ROW_ACTIONS_ORDER = ["view", "edit", "activate", "pause", "duplicate", "delete"];
const BULK_ACTIONS_ORDER = ["activate", "pause", "delete"];
export default function AllIncentives() {

   const { user } = useSelector((state) => state.auth);
 
   const token = `Bearer ${user?.token}`;

// icentive data
   const [incentives, setIncentives] = useState([]);
   const [incentiveTabs, setIncentiveTabs] = useState([]);


  // pagination
    const [paginationModel, setPaginationModel] = useState({
          page: 0, 
          pageSize: 15,
});

        const [paginationMeta, setPaginationMeta] = useState({
          current_page: 1,
          per_page: 15,
          total: 0,
          last_page: 1,
});



const navigate = useNavigate()



 // Filterations

const [filterAnchorEl, setFilterAnchorEl] = useState(null);
const isFilterOpen = Boolean(filterAnchorEl);

const [filters, setFilters] = useState({
  status: "",
  type: "",
  visibility: "",
});

const [tempFilters, setTempFilters] = useState(filters);

const handleFilterClick = (event) => {
  setTempFilters(filters); 
  setFilterAnchorEl(event.currentTarget);
  
};

const handleFilterClose = () => {
  setFilterAnchorEl(null);
};

const handleTempAutocompleteChange = (key) => (event, newValue) => {
  
  setTempFilters((prev) => ({
    ...prev,
    [key]: newValue?.value || "",
  }));
};

const handleApplyFilters = () => {
  setFilters(tempFilters);
  setFilterAnchorEl(null);
  setPaginationModel((prev) => ({ ...prev, page: 0 }));
  getAllIncentives(1, paginationModel.pageSize, tempFilters, searchTerm);
};

const handleResetFilters = () => {
  const cleared = { status: "", type: "", visibility: "" };
  setTempFilters(cleared);
  setFilters(cleared);
  setFilterAnchorEl(null);
  setPaginationModel((prev) => ({ ...prev, page: 0 }));
  getAllIncentives(1, paginationModel.pageSize, cleared, searchTerm);
};



const activeFiltersCount = Object.values(filters).filter(Boolean).length;


const [statusOptions, setStatusOptions] = useState([]);
const [typeOptions, setTypeOptions] = useState([]);
const [visibilityOptions, setVisibilityOptions] = useState([]);

const getFilterEnums = async () => {
  try {
    const [statusRes, typeRes, visibilityRes] = await Promise.all([
      axios.get(`${newHost}v1/incentives/enums/status`, {
        headers: { Authorization: token },
      }),
      axios.get(`${newHost}v1/incentives/enums/type`, {
        headers: { Authorization: token },
      }),
      axios.get(`${newHost}v1/incentives/enums/visibility`, {
        headers: { Authorization: token },
      }),
    ]);

    setStatusOptions(statusRes.data?.data?.enum || []);
    setTypeOptions(typeRes.data?.data?.enum || []);
    setVisibilityOptions(visibilityRes.data?.data?.enum || []);
  } catch (error) {
    console.log(error);
  }
};

useEffect(() => {
  getFilterEnums();
}, []);


// search

const [searchTerm, setSearchTerm] = useState("");
const searchDebounceRef = useRef(null);

const handleSearchChange = (event) => {
  const value = event.target.value;
  setSearchTerm(value);

  if (searchDebounceRef.current) {
    clearTimeout(searchDebounceRef.current);
  }

  searchDebounceRef.current = setTimeout(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    getAllIncentives(1, paginationModel.pageSize, filters, value);
  }, 500);
};

useEffect(() => {
  return () => {
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }
  };
}, []);


// get incentive


const getAllIncentives = async (
  page = paginationModel.page + 1,
  per_page = paginationModel.pageSize,
  currentFilters = filters,
  currentSearch = searchTerm
) => {
  try {
    const params = { page, per_page};

    Object.entries(currentFilters).forEach(([key, value]) => {
      
      if (value) {
        params[key] = value;
      }
    });

    if (currentSearch) {
      params.search = currentSearch;
    }

    const response = await axios.get(`${newHost}portal/incentives`, {
      headers: {
        Authorization: token,
      },
      params,
    });

    const responseData = response.data.data;

    console.log(responseData);

    setIncentives(responseData?.data || []);
    setPaginationMeta(responseData?.meta || {});
    setIncentiveTabs(responseData.tabs);
  } catch (error) {
    console.log(error);
  }
};

const [activeTab, setActiveTab] = useState("all");

const disabledTabKeys = ["needs_approval", "high_risk", "low_margin"];

const handleTabChange = (event, newTabKey) => {
  if (disabledTabKeys.includes(newTabKey)) return;

  setActiveTab(newTabKey);

  const newFilters = {
    ...filters,
    status: newTabKey === "all" ? "" : newTabKey,
  };

  setFilters(newFilters);
  setTempFilters(newFilters); 

  setPaginationModel((prev) => ({ ...prev, page: 0 }));
  getAllIncentives(1, paginationModel.pageSize, newFilters, searchTerm);
};

    const [menuState, setMenuState] = useState({ anchorEl: null, row: null });
    const handleClose = () => setMenuState({ anchorEl: null, row: null });
    const handleClick = (event, row) => setMenuState({ anchorEl: event.currentTarget, row });

   
    const [selectedRows, setSelectedRows] = useState([]);

    const handleRowAction = async (action, row) => {
  handleClose();

  try {
    switch (action) {
      case "view":
        navigate(`/incentives/${row.id}`);
        break;

      case "edit":
        navigate(`/incentives/${row.id}/edit`);
        break;

      case "activate":
        await axios.post(
          `${newHost}portal/incentives/${row.id}/activate`,
          {},
          { headers: { Authorization: token } }
        );
        getAllIncentives(paginationModel.page + 1, paginationModel.pageSize, filters, searchTerm);
        break;

      case "pause":
        await axios.post(
          `${newHost}portal/incentives/${row.id}/pause`,
          {},
          { headers: { Authorization: token } }
        );
        getAllIncentives(paginationModel.page + 1, paginationModel.pageSize, filters, searchTerm);
        break;

      case "delete":
        await axios.post(
          `${newHost}portal/incentives/${row.id}/disable`,
          {},
          { headers: { Authorization: token } }
        );
        getAllIncentives(paginationModel.page + 1, paginationModel.pageSize, filters, searchTerm);
        break;

      case "duplicate":
        
        break;

      // case "delete":
        
      //   break;

      default:
        break;
    }
  } catch (error) {
    console.log(error);
  }
};
const handleBulkAction = async (action) => {
  try {
    await axios.post(
      `${newHost}portal/incentives/all/bulk-action`,
      {
        ids: selectedRows,
        action,
      },
      { headers: { Authorization: token } }
    );

    setSelectedRows([]);
    getAllIncentives(paginationModel.page + 1, paginationModel.pageSize, filters, searchTerm);
  } catch (error) {
    console.log(error);
  }
};
const commonBulkActions = useMemo(() => {
  if (selectedRows.length === 0) return [];

  const selectedRowObjects = incentives.filter((row) =>
    selectedRows.includes(row.id)
  );

  if (selectedRowObjects.length === 0) return [];

  let common = selectedRowObjects[0].actions || [];

  for (let i = 1; i < selectedRowObjects.length; i++) {
    const rowActions = selectedRowObjects[i].actions || [];
    common = common.filter((action) => rowActions.includes(action));
  }

  return BULK_ACTIONS_ORDER.filter(
    (action) => common.includes(action) && ACTION_CONFIG[action]?.bulkEligible
  );
}, [selectedRows, incentives]);

const handleSelectRow = (id) => {
  setSelectedRows((prev) =>
    prev.includes(id)
      ? prev.filter((rowId) => rowId !== id)
      : [...prev, id]
  );
};
const handleClearSelection = () => {
  setSelectedRows([]);
};





useEffect(() => {
 getAllIncentives()
}, [])
const currentPageIds = incentives.map((row) => row.id);

const isAllCurrentPageSelected =
  incentives.length > 0 &&
  currentPageIds.every((id) =>
    selectedRows.includes(id)
  );

  return (
    <Box m={4}>
      <Grid container spacing={2}>
        {stats.map((item) => (
          <Grid item xs={12} md={2.4} key={item.title}>
            <Card
              className='shadow'
              elevation={0}
              sx={{
                border: "1px solid #ECECEC",
                borderRadius: "16px",

              }}
            >
              <CardContent>
                <div className='d-flex gap-2 align-items-center'>
                  <img src={statusIcon} alt="status" />
                  <Typography
                    fontSize={12}
                    color="text.secondary"
                  >
                    {item.title}
                  </Typography>
                </div>

                <Typography
                  mt={1}
                  fontWeight={700}
                  fontSize={18}
                >
                  {item.value}
                </Typography>

                <Typography
                  fontSize={12}
                  color={"#535353"}
                >
                  {item.subtitle}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box mt={3}>
        <Card
          elevation={0}
          sx={{
            border: "1px solid #ECECEC",
            borderRadius: 4,
            p: 3
          }}
        >
          <div className="d-flex justify-content-between align-items-center py-2 border-bottom">

            <Box display={"flex"} gap={1}>
              <LoopIcon />
              <Typography
                fontWeight={600}
              >
                Recently Updated
              </Typography>
            </Box>
            <Link sx={{ color: "#159D89", textDecorationLine: "none" }}>View all <ArrowForward fontSize='14px' /></Link>
          </div>

          <Grid
            container
            spacing={5}

          >
            {recentUpdates.map((item) => (
              <Grid
                item
                sm={12}
                md={2.4}
                key={item.name}
                sx={{ display: "flex", justifyContent: "start", mt: 3, alignItems:"center" }}


              >
                <div className="d-flex gap-2 align-items-center">
                  <Avatar
                    sx={{
                      bgcolor: item.bg,
                      color: item.color
                    }}
                  >
                    {item.initials}
                  </Avatar>

                  <div>
                    <Typography fontSize={14}>
                      {item.name}
                    </Typography>

                    <Typography
                      fontSize={12}
                      color="text.secondary"
                    >
                      Updated 2h ago
                    </Typography>
                  </div>
                </div>
              </Grid>

            ))}
          </Grid>
        </Card>
      </Box>
      <Box>
        <Paper
          sx={{
            mt: 3,
            p: 3,
            borderRadius: 4,
            border: "1px solid #E8E8E8"
          }}
          elevation={0}
        >
          <div className="d-flex justify-content-between align-items-center border-bottom">
            <div className="d-flex gap-2">
              <TrendingUp />
              <Typography
                fontWeight={600}
                mb={3}
              >

                Insight
              </Typography>

            </div>
            <div className="">
              <Link sx={{ color: "#159D89", textDecorationLine: "none" }}>View all <ArrowForward fontSize='14px' /></Link>
            </div>
          </div>

          <Grid container spacing={4} my={1} className='' >
            <Grid item xs={12} md={4} className='border-end pe-3'>
              <Typography mb={2} fontWeight={600}>
                Top Performance
              </Typography>

              <List>
                <ListItem>
                  <div className='d-flex justify-content-between w-100 my-2'>
                    <Typography fontSize={14}> Weekend Oil Offer</Typography>
                    <Typography fontSize={14}>ROI 4.5x</Typography>
                  </div>
                </ListItem>

                <ListItem>
                  <div className='d-flex justify-content-between w-100 my-2'>
                    <Typography fontSize={14}>Competition 100</Typography>
                    <Typography fontSize={14}>ROI 4.5x</Typography>
                  </div>
                </ListItem>

                <ListItem>
                  <div className='d-flex justify-content-between w-100 my-2'>
                    <Typography fontSize={14}>Welcome 2026</Typography>
                    <Typography fontSize={14}>ROI 4.5x</Typography>
                  </div>
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12} md={4} className='border-end pe-3'>
              <Typography mb={2} fontWeight={600}>
                Top Loss-Making
              </Typography>

              <List>
                <ListItem>
                  <div className='d-flex justify-content-between w-100 my-2'>
                    <Typography fontSize={14}>Oil Change Voucher</Typography>
                    <Typography color='#A80101' fontSize={14}>- 3,120 EGP</Typography>
                  </div>
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12} md={4} className=''>
              <Typography fontSize={14} mb={2} fontWeight={600}>
                Most Abused
              </Typography>

              <List>
                <ListItem>
                  <div className='d-flex justify-content-between w-100 my-2'>
                    <Typography fontSize={14}> Welcome 2026</Typography>
                    <Typography fontSize={14}>11</Typography>
                  </div>
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    <Box className="custom-tab-style" sx={{ marginBlock: 4, borderColor: "divider" }}>
  <Tabs
    value={activeTab}
    onChange={handleTabChange}
    variant="scrollable"
    scrollButtons="auto"
    sx={{ borderBottom: "1px solid #D8D8D8" }}
    TabIndicatorProps={{
      sx: {
        backgroundColor: "#3FBEAC",
        height: "3px",
      },
    }}
  >
    {incentiveTabs.map((tab) => (
      <Tab
        key={tab.key}
        value={tab.key}
        disabled={disabledTabKeys.includes(tab.key)}
        label={`${tab.label}${tab.count != null ? ` ${tab.count}` : ""}`}
        sx={{
          textTransform: "capitalize",
          fontSize: "15px",
          "&.Mui-disabled": {
            opacity: 0.5,
          },
        }}
      />
    ))}
  </Tabs>
</Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        my={3}
      >
        <div className="w-25">
         <FormControl fullWidth variant="outlined" size="small">
  <OutlinedInput
    id="search-incentive"
    placeholder="Search by name, code, type..."
    type="text"
    value={searchTerm}
    onChange={handleSearchChange}
    endAdornment={
      <InputAdornment position="start">
        <IconButton>
          <Search />
        </IconButton>
      </InputAdornment>
    }
  />
</FormControl>
        </div>
<Stack direction="row" spacing={2}>
  <button
    onClick={() => navigate("/incentives/createIncentive")}
    className="btn btn-dark px-3"
  >
    <AddIcon />
    Create Incentive
  </button>

  <button className="btn btn-light" onClick={handleFilterClick}>
    <FilterAltOutlinedIcon sx={{ color: "#535353" }} />
    Filter
    {/* {activeFiltersCount > 0 && (
      <Box
        sx={{
          bgcolor: "#000",
          color: "#fff",
          borderRadius: "50%",
          width: 18,
          height: 18,
          fontSize: 11,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ms: 1,
        }}
      >
        {activeFiltersCount}
      </Box>
    )} */}
  </button>

 <Menu
  anchorEl={filterAnchorEl}
  open={isFilterOpen}
  onClose={handleFilterClose}
  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
  transformOrigin={{ vertical: "top", horizontal: "left" }}
  PaperProps={{
    sx: { p: 2, width: 260, borderRadius: 2 },
  }}
>
  <Typography fontSize={14} fontWeight={600} sx={{ mb: 2 }}>
    Filter Incentives
  </Typography>

 <Stack spacing={2}>
  {/* STATUS */}
  <Autocomplete
    size="small"
    options={statusOptions}
    getOptionLabel={(opt) => opt.label || ""}
    isOptionEqualToValue={(opt, val) => opt.value === val.value}
    value={
      statusOptions.find((opt) => opt.value === tempFilters.status) || null
    }
    onChange={handleTempAutocompleteChange("status")}
    ListboxProps={{
      sx: {
        maxHeight: 220,
        overflowY: "auto",
      },
    }}
    renderOption={(props, option) => (
      <Box
        component="li"
        {...props}
        sx={{
          display: "flex",
          alignItems: "center",
           gap:"5px !important",
           p:"10px !important"
        }}
      >
        <Box
          component="span"
          sx={{  
            display: "inline-block",
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: option.color,
            mr: 1,
          }}
        />
        {option.label}
      </Box>
    )}
    renderInput={(params) => (
      <TextField {...params} label="Status" placeholder="All" />
    )}
  />

  {/* TYPE */}
  <Autocomplete
    size="small"
    options={typeOptions}
    getOptionLabel={(opt) => opt.label || ""}
    isOptionEqualToValue={(opt, val) => opt.value === val.value}
    value={typeOptions.find((opt) => opt.value === tempFilters.type) || null}
    onChange={handleTempAutocompleteChange("type")}
    ListboxProps={{
      sx: {
        maxHeight: 220,
        overflowY: "auto",
      },
    }}
    renderOption={(props, option) => (
      <Box
        component="li"
        {...props}
        sx={{
          display: "flex",
          alignItems: "center",
          gap:"5px !important",
        p:"10px !important"
        }}
      >
        <Box
          component="span"
          sx={{
            display: "inline-block",
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: option.color,
            mr: 1,
          }}
        />
        {option.label}
      </Box>
    )}
    renderInput={(params) => (
      <TextField {...params} label="Type" placeholder="All" />
    )}
  />

  {/* VISIBILITY */}
  <Autocomplete
    size="small"
    options={visibilityOptions}
    getOptionLabel={(opt) => opt.label || ""}
    isOptionEqualToValue={(opt, val) => opt.value === val.value}
    value={
      visibilityOptions.find((opt) => opt.value === tempFilters.visibility) ||
      null
    }
    onChange={handleTempAutocompleteChange("visibility")}
    ListboxProps={{
      sx: {
        maxHeight: 220,
        overflowY: "auto",
      },
    }}
    renderOption={(props, option) => (
      <Box component="li" {...props} sx={{ p:"10px !important"}}>
        {option.label}
      </Box>
    )}
    renderInput={(params) => (
      <TextField {...params} label="Visibility" placeholder="All" />
    )}
  />
</Stack>

  <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
    <button className="btn btn-light w-50" onClick={handleResetFilters}>
      Reset
    </button>
    <button className="btn btn-dark w-50" onClick={handleApplyFilters}>
      Apply
    </button>
  </Stack>
</Menu>

  <button className="btn btn-light">
    <FileDownloadOutlinedIcon sx={{ color: "#535353" }} />
    Export
  </button>
</Stack>      </Box>
      <div className="my-4">
      
    <Paper
      elevation={0}
      sx={{
        mb: 2,
        p: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        
      }}
    >
      <Box>
        <Typography fontSize={18} fontWeight={600}>All Incentives</Typography>
      </Box>
{selectedRows.length > 0 && (
  <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center", gap: 2 }}>
    <Box display="flex" alignItems="center">
      <Checkbox
        checked
        checkedIcon={
          <div
            style={{
              width: 22,
              height: 22,
              borderRadius: 4,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#000",
            }}
          >
            <CheckIcon style={{ color: "#fff", fontSize: 18 }} />
          </div>
        }
        size="small"
      />
      <Typography fontSize={14}>{selectedRows.length} selected</Typography>
    </Box>

    <Box sx={{ borderInlineEnd: "2px solid #BCBCBC", p: 2 }} />

    {commonBulkActions.length > 0 && (
      <>
        <Typography fontSize={14}>Bulk actions:</Typography>
        <Stack direction="row" spacing={1}>
          {commonBulkActions.map((action) => {
            const config = ACTION_CONFIG[action];
            return (
              <button
                key={action}
                style={{ border: `1px solid ${config.bulkBorderColor}`, fontSize: "14px" }}
                className="btn px-3 d-flex align-items-center gap-1"
                onClick={() => handleBulkAction(action)}
              >
                {config.bulkIcon}
                {config.label}
              </button>
            );
          })}
        </Stack>
        <Box sx={{ borderInlineEnd: "2px solid #BCBCBC", p: 2 }} />
      </>
    )}

    <button
      style={{ color: "#535353", fontSize: "14px" }}
      className="btn btn-outline-light px-3 d-flex align-items-center gap-1"
      onClick={handleClearSelection}
    >
      <CloseOutlined sx={{ color: "#535353" }} />
      Clear Selection
    </button>
  </Box>
)}
    </Paper>
  
 <Paper
  elevation={0}
  sx={{
    width: "100%",
    overflow: "hidden",
    border: "1px solid #E5E5E5",
    borderRadius: 2,
  }}
>
  <TableContainer
    sx={{
      width: "100%",
      overflowX: "auto",
    }}
  >
    <Table
      sx={{
        width: "100%",
        tableLayout: "fixed",
        "& .MuiTableCell-root": {
          fontSize: "13px",
          borderBottom: "1px solid #EEEEEE",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          py: 1.5,
          px: 1.5,
          textAlign: "center",
        },

        "& .MuiTableHead-root .MuiTableCell-root": {
          fontSize: "14px",
          fontWeight: 600,
          backgroundColor: "#FAFAFA",
          color: "#333333",
        },
        "& .css-1xtozoh-MuiTableRow-root.Mui-selected":{
          backgroundColor:"#F8F8F8 !important"
        }
      
      }}
    >
      {/* TABLE HEADER */}
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox" align="center" sx={{ width: 48 }}>
            <Checkbox
        
              size="small"
              checked={isAllCurrentPageSelected}
              indeterminate={
                currentPageIds.some((id) =>
                  selectedRows.includes(id)
                ) && !isAllCurrentPageSelected
              }
              onChange={(event) => {
                if (event.target.checked) {
                  // Add all current page IDs
                  setSelectedRows((prev) => [
                    ...new Set([
                      ...prev,
                      ...currentPageIds,
                    ]),
                  ]);
                } else {
                  // Remove only current page IDs
                  setSelectedRows((prev) =>
                    prev.filter(
                      (id) => !currentPageIds.includes(id)
                    )
                  );
                }
              }}
            />
          </TableCell>

          <TableCell align="center" sx={{ width: 70 }}>ID</TableCell>
          <TableCell align="center" sx={{ width: 180 }}>Incentive Name</TableCell>
          <TableCell align="center" sx={{ width: 110 }}>Type</TableCell>
          <TableCell align="center" sx={{ width: 110 }}>Trigger</TableCell>
          <TableCell align="center" sx={{ width: 100 }}>Priority</TableCell>
          <TableCell align="center" sx={{ width: 130 }}>Funding Source</TableCell>
          <TableCell align="center" sx={{ width: 100 }}>Risk</TableCell>
          <TableCell align="center" sx={{ width: 100 }}>Validity</TableCell>
          <TableCell align="center" sx={{ width: 140 }}>Budget Usage</TableCell>
          <TableCell align="center" sx={{ width: 110 }}>Redemptions</TableCell>
          <TableCell align="center" sx={{ width: 110 }}>Status</TableCell>
          <TableCell align="center" sx={{ width: 150 }}>Last Update</TableCell>
          <TableCell align="center" sx={{ width: 70 }}>Action</TableCell>
        </TableRow>
      </TableHead>

      {/* TABLE BODY */}
      <TableBody>
        {incentives.map((row) => {
          const isSelected = selectedRows.includes(row.id);

          return (
            <TableRow key={row.id} hover selected={isSelected}>
              {/* CHECKBOX */}
              <TableCell padding="checkbox" align="center">
                <Checkbox
                  size="small"
                  checked={selectedRows.includes(row.id)}
                  onChange={() => {
                    setSelectedRows((prev) =>
                      prev.includes(row.id)
                        ? prev.filter((id) => id !== row.id)
                        : [...prev, row.id]
                    );
                  }}
                />
              </TableCell>

              {/* ID */}
              <TableCell align="center">{row.id}</TableCell>

              {/* INCENTIVE NAME */}
              <TableCell align="center">{row.name || "-"}</TableCell>

              {/* TYPE */}
              <TableCell align="center">
                <Chip
                  label={row.type?.label || "-"}
                  size="small"
                  sx={{
                    bgcolor: row.type?.bg_color,
                    color:row.type?.text_color,
                    p:1
                  }}
                />
              </TableCell>

              {/* TRIGGER */}
              <TableCell align="center">
                {row.trigger?.label || "-"}
              </TableCell>

              {/* PRIORITY */}
              <TableCell align="center">
                <Chip
                  label={row.priority?.label || "-"}
                  size="small"
                   sx={{
                    bgcolor: row.priority?.bg_color,
                    color:row.priority?.text_color,
                    p:1
                  }}
                />
              </TableCell>

              {/* FUNDING SOURCE */}
              <TableCell align="center">
                {row.funding?.source || "-"}
              </TableCell>

              {/* RISK */}
              <TableCell align="center">
                <Chip
                  label={row.risk?.label || "-"}
                  size="small"
                  sx={{
                    bgcolor: "transparent",
                  }}
                />
              </TableCell>

              {/* VALIDITY */}
              <TableCell align="center">
                {row.validity?.type || "-"}
              </TableCell>

              {/* BUDGET USAGE */}
              <TableCell align="center">
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography fontSize={13}>
                    {`${row.budget?.used_percentage ?? 0}%`}
                  </Typography>

                  <LinearProgress
                    variant="determinate"
                    value={row.budget?.used_percentage ?? 0}
                    sx={{
                      width: "100%",
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: "#DADADA",

                      "& .MuiLinearProgress-bar": {
                        borderRadius: 10,
                      },
                    }}
                  />
                </Box>
              </TableCell>

              {/* REDEMPTIONS */}
              <TableCell align="center">
                {row.redemptions?.count ?? 0}
              </TableCell>

              {/* STATUS */}
              <TableCell align="center">

                <Chip
                  label={  <Box
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        <FaCircle
                                           size={7}
                                           color={row.status?.color}
                                        />
                                      <Typography fontSize={12}>{row.status.label || "-"}</Typography>
                                    </Box>}
                  size="small"

                  sx={{
                    fontWeight: 500,
                      bgcolor: row.status?.bg_color,
                    color:row.status?.text_color,
                    p:1
                  }}
                
                />
                     
                                
              </TableCell>

              {/* LAST UPDATE */}
              <TableCell align="center">
                <Box>
                  <Typography fontSize={13} component="div">
                    {row.last_update?.at
                      ? `${new Date(
                          row.last_update.at
                        ).toLocaleDateString()} ${new Date(
                          row.last_update.at
                        ).toLocaleTimeString()}`
                      : "-"}
                  </Typography>

                  <Typography fontSize={12}>
                    {`by ${row.last_update?.by?.name || "-"}`}
                  </Typography>
                </Box>
              </TableCell>

              {/* ACTION */}
              <TableCell align="center">
              <IconButton
                        disableRipple
                        size="small"
                        onClick={(e) => {
                            handleClick(e, row);
                            e.stopPropagation();
                        }}
                    >
                        <MoreVertIcon fontSize="small" />
                    </IconButton>
                 <Menu
  anchorEl={menuState.anchorEl}
  open={Boolean(menuState.anchorEl) && menuState.row?.id === row.id}
  onClose={handleClose}
  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
  transformOrigin={{ vertical: "top", horizontal: "right" }}
  slotProps={{ paper: { sx: { borderRadius: 2, p: 1, backgroundColor: "#F9F9F9" } } }}
>
  {ROW_ACTIONS_ORDER.filter((action) => row.actions?.includes(action)).map(
    (action) => {
      const config = ACTION_CONFIG[action];
      return (
        <MenuItem
          key={action}
          className="p-1"
          sx={{ display: "flex", gap: 1, borderRadius: 1, color: config.color }}
          onClick={() => handleRowAction(action, row)}
        >
          {config.icon} {config.label}
        </MenuItem>
      );
    }
  )}
</Menu>
              </TableCell>
            </TableRow>
          );
        })}

        {/* EMPTY STATE */}
        {incentives.length === 0 && (
          <TableRow>
            <TableCell colSpan={14} align="center" sx={{ py: 5 }}>
              No incentives found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>

  {/* PAGINATION */}
  <TablePagination
    component="div"
    count={paginationMeta.total || 0}
    page={paginationModel.page}
    rowsPerPage={paginationModel.pageSize}
  // في الـ TablePagination
onPageChange={(event, newPage) => {
  setPaginationModel((prev) => ({ ...prev, page: newPage }));
  getAllIncentives(newPage + 1, paginationModel.pageSize, filters, searchTerm);
}}

onRowsPerPageChange={(event) => {
  const newPageSize = parseInt(event.target.value, 10);
  setPaginationModel({ page: 0, pageSize: newPageSize });
  getAllIncentives(1, newPageSize, filters, searchTerm);
}}
    rowsPerPageOptions={[5, 10, 15, 20, 50]}
  />
</Paper>



      </div>
      <div>
        <Grid container spacing={4} my={1} className='' >
          <Grid item xs={12} md={4} className=''>

            <Card sx={{ border: "1px solid #E8E8E8", borderRadius: 3, p: 2, height: "220px" }}>
              <Box
                borderBottom={"1px solid #E8E8E8"}
                py={1} display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"} >
                <Typography>
                  Live Order Impact
                </Typography>
                <Typography variant='body2' color='#535353'>
                  Updated just now
                </Typography>
              </Box>

              <List sx={{listStyle:""}}>
                <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                  <div className='d-flex justify-content-between w-100 my-2 py-1'>
                    <Typography fontSize={14}> Active Orders Affected</Typography>
                    <Typography fontSize={14}>214</Typography>
                  </div>
                </ListItem>

                <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                  <div className='d-flex justify-content-between w-100 my-2 py-1'>
                    <Typography fontSize={14}>Blocked Orders</Typography>
                    <Typography fontSize={14}>38</Typography>
                  </div>
                </ListItem>

                <ListItem>
                  <div className='d-flex justify-content-between w-100 my-2 py-1'>
                    <Typography fontSize={14}>Recalculated Orders</Typography>
                    <Typography fontSize={14}>17</Typography>
                  </div>
                </ListItem>
              </List>
            </Card>

          </Grid>
          <Grid item xs={12} md={4} className=''>

            <Card sx={{ border: "1px solid #E8E8E8", borderRadius: 3, p: 2, height: "220px" }}>
              <Box
                borderBottom={"1px solid #E8E8E8"}
                py={1} display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"} >
                <Typography>
                  Approval Center
                </Typography>
                <Link sx={{ color: "#159D89", textDecorationLine: "none" }}>View all <ArrowForward fontSize='14px' /></Link>
              </Box>

              <List>
                <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                  <div className='row w-100 my-2 py-1'>
                    <div className='col-md-6 col-12 d-flex justify-content-start'>
                      <Typography fontSize={14}>Battery Supplier Campaign</Typography>
                    </div>
                    <div className="col-md-4 col-12 d-flex justify-content-center">
                      <Chip
                        label={"High Budget"}
                        size="small"
                        sx={{
                          borderRadius: "16px",
                          fontWeight: 700,
                          color: "#A80101",
                          bgcolor: "#FFF4F0"
                        }}
                      />
                    </div>

                    <div className="col-md-2 col-12 d-flex justify-content-end">
                      <Typography fontSize={14}>214</Typography>
                    </div>

                  </div>
                </ListItem>

                <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                  <div className='row w-100 my-2 py-1'>
                    <div className="col-md-6 col-12 d-flex justify-content-start">
                      <Typography fontSize={14}>Referral Promo Q2</Typography>
                    </div>
                    <div className="col-md-4 col-12 d-flex justify-content-center">
                      <Chip
                        label={"Provider Funded"}
                        size="small"
                        sx={{
                          borderRadius: "16px",
                          fontWeight: 700,
                          color: "#159D89",
                          bgcolor: "#ECF9F7"
                        }}
                      />
                    </div>
                    <div className="col-md-2 col-12 d-flex justify-content-end">
                      <Typography fontSize={14}>38</Typography>
                    </div>

                  </div>
                </ListItem>

                <ListItem>
                  <div className='row w-100 my-2 py-1'>
                    <div className="col-md-6 col-12 d-flex justify-content-start">
                      <Typography fontSize={14}>Mega Weekend Offer</Typography>
                    </div>
                    <div className="col-md-4 col-12 d-flex justify-content-center">
                      <Chip
                        label={"High Risk"}
                        size="small"
                        sx={{
                          borderRadius: "16px",
                          fontWeight: 700,
                          color: "#A80101",
                          bgcolor: "#FFF4F0"
                        }}
                      />
                    </div>
                    <div className="col-md-2 col-12 d-flex justify-content-end">
                      <Typography fontSize={14}>17</Typography>
                    </div>



                  </div>
                </ListItem>
              </List>
            </Card>

          </Grid>
          <Grid item xs={12} md={4} className=''>

            <Card sx={{ border: "1px solid #E8E8E8", borderRadius: 3, p: 2, height: "220px" }}>
              <Box
                borderBottom={"1px solid #E8E8E8"}
                py={1} display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"} >
                <Typography>
                  System Status
                </Typography>
                <Typography variant='body2' color='#535353'>
                  Last Checked: 2 min ago
                </Typography>
              </Box>

              <List>
                <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                  <div className='row w-100 my-2 py-1'>
                    <div className="col-md-5 col-12 d-flex justify-content-start">
                      <Typography fontSize={14}>Incentives Engine</Typography>
                    </div>
                    <div className="col-md-3 col-12 d-flex justify-content-center">
                      <Typography fontSize={14} color='#159D89'>Operational</Typography>
                    </div>
                    <div className="col-md-4 col-12 d-flex justify-content-end">
                      <Typography fontSize={14}>110 ms</Typography>
                    </div>



                  </div>
                </ListItem>

                <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                  <div className='row w-100 my-2 py-1'>
                    <div className="col-md-5 col-12 d-flex justify-content-start">
                      <Typography fontSize={14}>Redemption Service</Typography>
                    </div>
                    <div className="col-md-3 col-12 d-flex justify-content-center">
                      <Typography fontSize={14} color='#159D89'>Operational</Typography>
                    </div>
                    <div className="col-md-4 col-12 d-flex justify-content-end">
                      <Typography fontSize={14}>98 ms</Typography>
                    </div>



                  </div>
                </ListItem>

                <ListItem>
                  <div className='row w-100 my-2 py-1'>
                    <div className="col-md-5 col-12 d-flex justify-content-start">
                      <Typography fontSize={14}>Budget Service</Typography>
                    </div>
                    <div className="col-md-3 col-12 d-flex justify-content-center">
                      <Typography fontSize={14} color='#159D89'>Operational</Typography>
                    </div>
                    <div className="col-md-4 col-12 d-flex justify-content-end">
                      <Typography fontSize={14}>110 ms</Typography>
                    </div>


                  </div>
                </ListItem>
              </List>
            </Card>

          </Grid>
        </Grid>
      </div>
    </Box>
  )
}
